import { Component, OnInit, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Validators, FormBuilder, FormControl } from "@angular/forms";
import { AuthService } from "src/providers/auth.service";
import { HttpService } from "src/providers/http.service";
import { ENV } from "src/environments/environment-variables.token";
import { UtilsProvider } from "src/commons/utils";

@Component({
    selector: "app-layout",
    templateUrl: "./layout.component.html",
    styleUrls: ["./layout.component.scss", "../app.component.scss"],
})
export class LayoutComponent implements OnInit {
    public loginForm: any;
    public loginFormStep: any;
    options: any;
    constructor(
        public router: Router,
        public formBuilder: FormBuilder,
        public auth: AuthService,
        public http: HttpService,
        public utils: UtilsProvider,
        @Inject(ENV) public ENV: any
    ) { }

    ngOnInit() {
        this.setOptions();

	}


	setOptions() {
		const self = this;
		const params = {
			page: 0,
			perPage: 10,
        };
		this.options = {
			url: "api/institution/institution/getAllSearch",
			headers: [{ text: "Título", value: "title" }, { text: "Descrição", value: "description" }],
			cols: [{ field: "title", pipe: null }, { field: "description", pipe: null }],
			perPage: 20,
			edit: (item) => {


			},
			controller: this
		};
	}


}
